import { useState } from "react";
import Section from "../../parts/Section";
import EquipmentsForm from "./Form";
import { brlToInt } from "../../utils";
import { useNavigate } from "react-router-dom";
import Api from "../../Api";
import { EquipmentUI, UIValue } from "../../types";

const EquipmentsCreate = () => {
  const navigate = useNavigate();
  const [equipment, setEquipment] = useState<EquipmentUI>({
    uuid: "",
    name: "",
    categoryUuid: "",
    brand: "",
    price: "",
    rent: "",
    canSell: false,
    canRent: false,
  });
  const [error, setError] = useState(false);

  const updateEquipment = (key: string) => (value: UIValue) => {
    setEquipment((equipment) => ({ ...equipment, [key]: value }));
  };

  const save = async () => {
    const payload = {
      ...equipment,
      price: brlToInt(equipment.price),
      rent: brlToInt(equipment.rent),
    };
    const result = await Api.equipmentsCreate(payload);
    result.success ? navigate("/equipamentos") : setError(true);
  };

  return (
    <Section className="p-4 pb-32">
      <EquipmentsForm
        equipment={equipment}
        onChange={updateEquipment}
        onSubmit={save}
        error={error}
      />
    </Section>
  );
};

export default EquipmentsCreate;
